/**
 * A post-sign-in destination (`next`) that stays on this site: a path starting with a single "/".
 * Protocol-relative ("//evil.example"), backslash ("/\evil.example") and absolute URLs, and paths
 * with control characters, fall back to `fallback`. Every place that honors `next` uses this.
 */
export function safePath(p: string | null | undefined, fallback = '/home'): string {
  if (!p || !p.startsWith('/') || p.startsWith('//') || p.startsWith('/\\')) return fallback;
  if (/[\u0000-\u001f\u007f\\]/.test(p)) return fallback;
  return p;
}

/** A user-supplied address usable as a link: only absolute http(s) URLs, otherwise null. */
export function safeHttpUrl(raw: string | null | undefined): string | null {
  if (!raw) return null;
  try {
    const u = new URL(raw);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.toString() : null;
  } catch {
    return null;
  }
}
